// extracted by mini-css-extract-plugin
export default {"AlertsPanel":"AlertsPanel_AlertsPanel__GFSGU","buttonsPanel":"AlertsPanel_buttonsPanel__ctZod"};